import React from 'react';
import { Button, FormGroup, Input } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faSave } from '@fortawesome/free-solid-svg-icons';
import { util } from '../Util';
import { ApiRoutes } from '../ApiRoutes';
import { FormLabel, toasty } from '../common/forms/FormElements';
import _ from 'lodash-es';

export default class BrokerDefaultCapacityManager extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editEnabled: false,
            updatedBrokerDefaultCapacity: {},
            anyChanges: false,
        };
    }

    onDefaultQuantityChange = (e) => {
        const { updatedBrokerDefaultCapacity } = this.state;

        updatedBrokerDefaultCapacity.maximumAssignmentCount = e.target.value;

        this.setState({ updatedBrokerDefaultCapacity, anyChanges: true });
    };

    onSaveDefaultQuantity = async () => {
        this.setState({ saving: true });

        const { updatedBrokerDefaultCapacity } = this.state;
        const { onDefaultCapacityUpdated } = this.props;

        try {
            const responseBrokerDefaultCapacity =
                await util.fetch.andGetResponse(
                    util.fetch.types.post,
                    ApiRoutes.brokerDefaultCapacity.upsert(),
                    updatedBrokerDefaultCapacity
                );

            toasty.success('Default Capacity Updated');

            this.setState({
                saving: false,
                editEnabled: false,
                anyChanges: false,
            });

            onDefaultCapacityUpdated(responseBrokerDefaultCapacity);
        } catch (e) {
            console.error({ e });

            this.setState({ saving: false });
        }
    };

    getInvalid = () => {
        const { updatedBrokerDefaultCapacity } = this.state;

        return (
            !updatedBrokerDefaultCapacity ||
            !updatedBrokerDefaultCapacity.maximumAssignmentCount ||
            updatedBrokerDefaultCapacity.maximumAssignmentCount < 0
        );
    };

    toggleEditMode = () => {
        const { editEnabled } = this.state;

        if (!editEnabled) {
            const { brokerDefaultCapacity } = this.props;

            this.setState({
                updatedBrokerDefaultCapacity: _.cloneDeep(
                    brokerDefaultCapacity
                ),
                anyChanges: false,
            });
        }

        this.setState({ editEnabled: !editEnabled });
    };

    render() {
        const { brokerDefaultCapacity } = this.props;

        const {
            editEnabled,
            updatedBrokerDefaultCapacity,
            saving,
            anyChanges,
        } = this.state;

        const invalid = this.getInvalid();

        return (
            <div className="d-flex">
                <div className="w-50">
                    {!editEnabled && (
                        <FormGroup>
                            <FormLabel
                                text="Default Maximum Number Of Assignments"
                                htmlFor="maximumAssignmentCount"
                            />

                            <Input
                                type="number"
                                id="maximumAssignmentCount"
                                value={
                                    brokerDefaultCapacity.maximumAssignmentCount
                                }
                                disabled
                                readOnly
                            />
                        </FormGroup>
                    )}

                    {editEnabled && (
                        <FormGroup>
                            <FormLabel
                                text="Default Maximum Number Of Assignments"
                                htmlFor="maximumAssignmentCount"
                                required={true}
                            />

                            <Input
                                type="number"
                                min={0}
                                step={1}
                                id="maximumAssignmentCount"
                                onChange={this.onDefaultQuantityChange}
                                invalid={invalid}
                                value={
                                    updatedBrokerDefaultCapacity.maximumAssignmentCount
                                }
                            />
                        </FormGroup>
                    )}
                </div>

                <div className="align-content-center ml-auto">
                    <Button
                        type="button"
                        onClick={this.toggleEditMode}
                        color="warning"
                        outline={editEnabled}
                    >
                        <FontAwesomeIcon icon={faEdit} />
                        {editEnabled && <>Cancel Edit</>}
                        {!editEnabled && <>Edit</>}
                    </Button>

                    <Button
                        type="button"
                        onClick={this.onSaveDefaultQuantity}
                        color="info"
                        className="ml-5"
                        outline={!editEnabled}
                        disabled={!editEnabled || !anyChanges || saving}
                    >
                        <FontAwesomeIcon icon={faSave} pulse={saving} /> Save
                    </Button>
                </div>
            </div>
        );
    }
}
